/**
 * @generated SignedSource<<6a30acf094d843f180af74244c6356f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteInstructorImplInput = {
  clientMutationId?: string | null | undefined;
  ids: ReadonlyArray<string>;
};
export type InstructorsTable_DeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteInstructorImplInput;
};
export type InstructorsTable_DeleteMutation$data = {
  readonly Admin: {
    readonly Instructor: {
      readonly deleteInstructorImpl: {
        readonly deletedIds: ReadonlyArray<string>;
      } | null | undefined;
    };
  };
};
export type InstructorsTable_DeleteMutation = {
  response: InstructorsTable_DeleteMutation$data;
  variables: InstructorsTable_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InstructorsTable_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InstructorAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Instructor",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteInstructorImplPayload",
                "kind": "LinkedField",
                "name": "deleteInstructorImpl",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "InstructorsTable_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InstructorAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Instructor",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteInstructorImplPayload",
                "kind": "LinkedField",
                "name": "deleteInstructorImpl",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d25f1a36060c9fa51d831bf25423de31",
    "id": null,
    "metadata": {},
    "name": "InstructorsTable_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation InstructorsTable_DeleteMutation(\n  $input: DeleteInstructorImplInput!\n) {\n  Admin {\n    Instructor {\n      deleteInstructorImpl(input: $input) {\n        deletedIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc99c0fbfb0008ee158632c4fe3fe81d";

export default node;
